<template>
  <div class="wallet-details">
    <van-cell-group>
      <van-cell :border="false" class="sub-title" :value="settlementDetail.tradeMoney | money">
        <template #title>
          <span>提现金额</span>
          <van-tag :type="settlementDetail.status === 1 ? 'warning' : 'success'">{{ settlementDetail.status | status }}</van-tag>
        </template>
      </van-cell>
      <van-cell :border="false" title="结算单号:" :value="settlementDetail.orderNo" />
      <van-cell :border="false" title="申请时间:" :value="settlementDetail.created" />
      <van-cell :border="false" title="申请人:" :value="settlementDetail.staffName" />
      <van-cell :border="false" title="钱包余额:" :value="settlementDetail.balance | money" />
      <van-cell :border="false" title="提现金额:" :value="settlementDetail.tradeMoney | money" />
      <van-cell :border="false" title="提现类型:" :value="settlementDetail.type | type" />
      <div class="table-divider">
        <van-divider />
      </div>
      <van-cell :border="false" title="姓名:" :value="settlementDetail.bankCardUserName" />
      <van-cell :border="false" title="开户行:" :value="settlementDetail.bankName" />
      <van-cell :border="false" title="银行卡号:" :value="settlementDetail.bankCard" />
      <van-cell :border="false" title="开户网点:" :value="settlementDetail.bankAddress" />
      <div class="table-divider">
        <van-divider />
      </div>
      <van-cell :border="false" title="结算时间:" :value="settlementDetail.modified" />
      <van-cell :border="false" title="结算人:" :value="settlementDetail.operatorName" />
      <van-cell :border="false" title="结算状态:" :value="settlementDetail.status | status" />
      <van-cell :border="false" title="备注:" :value="settlementDetail.remark" />
      <van-row v-if="settlementDetail.content" class="img-wrap" gutter="20">
        <van-col
          v-for="item in settlementDetail.content.split(',')"
          :key="item"
          :span="6"
        >
          <ShowImage :url="item" />
        </van-col>
      </van-row>
    </van-cell-group>
  </div>
</template>

<script>
import ShowImage from '@/components/img/showImage';
import { settlementDetail } from '@/api/wallet'
export default {
  components: { ShowImage },
  data() {
    return {
      settlementDetail: {}
    }
  },
  created() {
    this.getSettlementDetail();
  },
  filters: {
    status(value) {
      switch(value) {
        case 1:
          return '财务处理中';
        case 2:
          return '已结算';
        default:
          return '';
      }
    },
    type(value) {
      switch(value) {
        case 0:
        case 1:
        case 3:
          return '员工提现';
        case 2:
          return '合伙人提现';
        default:
          return '';
      }
    }
  },
  methods: {
    getSettlementDetail() {
      const { params } = this.$route;
      settlementDetail({ id: parseInt(params.id) }).then(res => {
        if (res.errcode === 0) {
          this.settlementDetail = res.data;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wallet-details {
  .van-cell-group {
    &::after { display: none; }
  }
  margin-top: 10px;
  .sub-title { color: #333;
    .van-cell__title { font-size: 14px !important; }
    .van-cell__value { font-size: 16px !important; }
    .van-tag { margin-left: 15px; }
  }
  .van-cell {
    &:not(:first-of-type) { padding: 5px 16px; }
    .van-cell__title { font-weight: 500; font-size: 12px; }
    .van-cell__value { font-size: 12px; color: #333; }
  }
  .table-divider {
    padding: 0 50px;
    .van-divider { margin: 10px 0; }
  }
  .img-wrap { padding: 0 16px; }
}
</style>